/**
 * Created by Ning Jiang on 10/10/2018.
 */

import {BitmapWinCountUp} from "@nolimitcity/slot-game/bin/game/winpresentation/countup/BitmapWinCountUp";
import {Power2, Timeline, TimelineLite, TweenLite, Elastic} from "gsap";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {IResizeData} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";

export class GGBigWinCountUp extends BitmapWinCountUp {

    private _countUpComplete:boolean;
    private _isShowing:boolean = false;

    private _finishingTimeline:TimelineLite;

    constructor() {
        super({
            font : {
                name : "EvilGoblins_countUp",
                size : 50
            },
            tint : parseInt(("#ffffff").replace(/^#/, ''), 16)
        });
        EventHandler.addEventListener(this, SpinEvent.BEFORE_START, (event:GameEvent) => this.onRemove());
    }

    protected isFontEvenWidth():boolean {
        return false;
    }

    protected initAnimations():void {
        super.initAnimations();
        this._countUp.letterSpacing = -5;
        (<PIXI.Point>this._countUp.anchor).set(0, -1);
    }

    public getCountUpAnimation(from:number, to:number, duration:number):Timeline {
        this.setCountUpYPos();

        this.alpha = 1;
        const timeline:TimelineLite = new TimelineLite();
        timeline.add([
            () => {
                this._countUp.alpha = 1;
                this._countUp.visible = true;
                this._isShowing = true;
                this._countUpComplete = false;
            },
            this._countUp.getCountUpAnimation(from, to, {
                duration : duration,
                ease : Power2.easeIn
            }),
            TweenLite.fromTo(this._countUpContainer.scale, 1,
                {x : 0.5, y : 0.5},
                {
                    x : 1,
                    y : 1,
                    ease : Elastic.easeOut.config(3, 1)
                })
        ]);

        return timeline;
    }

    public abort(endValue:number, isAborted:boolean):Timeline | null {
        // Logger.logDev(`------------------------BigWinCountUp.abort(endValue: ${endValue}, isAborted: ${isAborted}, this.alpha = ${this._countUp.alpha})`);
        // Logger.logDev(`------------------------BigWinCountUp.abort(_countUpComplete: ${this._countUpComplete}, this.alpha = ${this._countUp.alpha})`);
        if(this._countUpComplete) {
            return null;
        }

        const timeline:Timeline = super.abort(endValue, isAborted)!;
        // timeline.add(() => this.stopCountUpSound(), 0);
        timeline.play();

        return timeline;
    }

    protected getAbortAnimation(endValue:number):Timeline {
        this.alpha = 1;
        const timeline:TimelineLite = new TimelineLite();
        timeline.add([
            () => {
                this._countUp.alpha = 1;
                this._countUp.visible = true;
                this._isShowing = true;
            },
            TweenLite.fromTo(this._countUpContainer.scale, 0.2,
                {x : 0.5, y : 0.5},
                {
                    x : 1,
                    y : 1,
                    ease : Elastic.easeOut.config(2, 1)
                }),
            this._countUp.getCountUpAnimation(endValue, endValue, {duration : 0.01})
        ]);
        timeline.add(()=>this.onRemove());
        return timeline;
    }

    public getEndingAnimation(endValue:number):Timeline {
        const timeline:TimelineLite = new TimelineLite();
        timeline.add([
            this._countUp.getCountUpAnimation(endValue, endValue, {duration : 0.01})
        ]);
        timeline.add(TweenLite.to(this._countUpContainer.scale, 0.3, {
            x :  1.05,
            y :  1.05,
            ease : Elastic.easeOut.config(2, 0.75),
        }));
        timeline.add(TweenLite.to(this._countUpContainer.scale, 0.5, {
            x : 0.6,
            y : 0.6,
            ease : Elastic.easeOut.config(1, 1),
            // ease: Power4.easeOut
        }));
        timeline.add(()=>this.onRemove());
        return timeline;
    }

    private onRemove():void {
        if(this._isShowing) {
            this.getRemoveAnimation();
        }else{
            this._countUpComplete = true;
        }

    }

    private getRemoveAnimation():void {
        this._isShowing = false;
        const timeline = new TimelineLite();
        timeline.add([
            TweenLite.to(this._countUp, 0.3, {alpha : 0, ease : Power2.easeIn}),
            TweenLite.to(this._countUpContainer, 0.3, {y : -100, ease : Power2.easeIn})
        ], 0.2); // stay a while after count up.
        timeline.add(() => {
            this._countUpContainer.y = 0;
            this._countUpComplete = true;
        });
        this._finishingTimeline = timeline
    }

    // #504
    protected onResize(resizeData: IResizeData) {
        super.onResize && super.onResize(resizeData);

        this.setCountUpYPos();
    }

    // #504
    private setCountUpYPos(): void {
        if (NolimitApplication.isLandscape) {
            this.y = 450;
        } else {
            this.y = 320;
        }
    }
}